var _defs, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#202020;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_settings_module") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.37,27.68l-3.2-.62a19.11,19.11,0,0,0-1.42-4.86L50.12,20a1.5,1.5,0,0,0,.14-2l-4.07-5.07a1.51,1.51,0,0,0-2-.31l-2.71,1.83A19.33,19.33,0,0,0,37,11.93l.08-3.26a1.5,1.5,0,0,0-1.33-1.53l-6.47-.71a1.5,1.5,0,0,0-1.64,1.2l-.62,3.2a19.11,19.11,0,0,0-4.86,1.42L20,9.88a1.5,1.5,0,0,0-2-.14l-5.07,4.07a1.51,1.51,0,0,0-.31,2l1.83,2.71A18.83,18.83,0,0,0,11.93,23l-3.26-.09a1.52,1.52,0,0,0-1.53,1.34l-.72,6.46a1.51,1.51,0,0,0,1.21,1.64l3.2.62a19.11,19.11,0,0,0,1.42,4.86L9.88,40.05a1.5,1.5,0,0,0-.14,2l4.07,5.07a1.51,1.51,0,0,0,2,.31l2.71-1.83A19.4,19.4,0,0,0,23,48.07l-.08,3.26a1.49,1.49,0,0,0,1.33,1.53l6.47.71h.16a1.49,1.49,0,0,0,1.47-1.21l.63-3.2a19.23,19.23,0,0,0,4.86-1.42l2.25,2.37a1.49,1.49,0,0,0,2,.14l5.08-4.07a1.5,1.5,0,0,0,.3-2l-1.83-2.71A18.83,18.83,0,0,0,48.07,37l3.26.09a1.48,1.48,0,0,0,1.53-1.34l.72-6.46A1.51,1.51,0,0,0,52.37,27.68ZM37.6,30.84A7.64,7.64,0,1,1,36,25.22,7.59,7.59,0,0,1,37.6,30.84Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.22,
    y: 0.04,
    width: 60,
    height: 60
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleSettings);
export default __webpack_public_path__ + "static/media/icon_module_settings.87e560963bb41a95f806741ef3c83013.svg";
export { ForwardRef as ReactComponent };